import { getStore } from "@shared/utils.locale";
import isAbsoluteUrl from "is-absolute-url";

import { StoreType } from "@beautypie/core";

export const navigateTo = (
  url: string,
  store?: StoreType | undefined
): void => {
  if (typeof window === "undefined") return;
  const locale = store ?? getStore();
  const isAbsolute = isAbsoluteUrl(url);
  const href = locale === "us" ? `/us${url}` : url;
  window.location.href = isAbsolute ? url : href;
};
